import { render } from "./StatusComponent.vue?vue&type=template&id=86b4e500"
import script from "./StatusComponent.vue?vue&type=script&lang=js"
export * from "./StatusComponent.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__